"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BingMap = void 0;
var _mui = require("@ori-ui/mui");
var _logger = require("@ori/logger");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useBingMap = require("../../hooks/useBingMap");
var _models = require("../../models");
var _Loading = require("../Loading");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
// Hiding map container, but keeping map in same initialized state.
// This way, the parent div wrappers should not break the layout.
const MapContainer = (0, _mui.styled)('div')(({
  ownerState: {
    isMapVisible
  }
}) => ({
  ...(!isMapVisible && (0, _shared.hiddenMapStyles)())
}));
const BingMap = props => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    isMapVisible
  } = props;
  const {
    isLoading,
    mapContainer,
    error
  } = (0, _useBingMap.useBingMap)(props);
  const logger = (0, _logger.useLogger)('useBingMap');
  if (error) {
    logger.error(error, {
      action: 'loadMap'
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isLoading && isMapVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.MapLoadingOverlay, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(MapContainer, {
      ref: mapContainer,
      ownerState: {
        isMapVisible
      },
      ...getTestIdProps(_models.TestId.BingMapContainer)
    })]
  });
};
exports.BingMap = BingMap;
var _default = exports.default = BingMap;